import React, { useState } from 'react';
import AdminListGrid from './AdminListGrid';
import QuestionAuditGrid from './QuestionAuditGrid';
import AdminStatsDashboard from './AdminStatsDashboard';

const TABS = [
    { key: 'admins', label: 'Admins' },
    { key: 'questions', label: 'Questions Audit' },
    { key: 'stats', label: 'Stats' },
];

export default function AdminManagement() {
    const [activeTab, setActiveTab] = useState('admins');

    return (
        <div className="container mt-4">
            <h2 className="mb-3">Admin Management</h2>
            <ul className="nav nav-tabs mb-3">
                {TABS.map(tab => (
                    <li className="nav-item" key={tab.key}>
                        <button
                            className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.key)}
                            type="button"
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>
            {activeTab === 'admins' && <AdminListGrid />}
            {activeTab === 'questions' && <QuestionAuditGrid />}
            {activeTab === 'stats' && <AdminStatsDashboard />}
        </div>
    );
}
